import axios from "axios";
import { APIOverrides } from "../../ApiOverrides";
import type { BroadcastResult, BroadcastTarget, DiscordPlayerStatsProps, PublicPlayerProps, ServersResponse } from "../../types";

let BOT_SVC_API = ''
let AUTH_SVC_API = ''
export const BettorBotApi = {
    setEnvironment: () => {
        const endpoints = APIOverrides.getEndpoints();
        AUTH_SVC_API = endpoints['AUTH_SVC_API'] as string;
        BOT_SVC_API = endpoints['BOT_SVC_API'] as string;
    },
    getServers: async():Promise<ServersResponse> => {
        try {
            console.log('Starting HERE!!!')
            console.log(BOT_SVC_API)
            const resp = await axios.get(`${BOT_SVC_API}/servers`);
            console.log(resp.data)
            return resp.data
        } catch (e) {
            console.log(e)
            return { totalGuilds: 0, error:'Unable to get data', servers: [] }
        }
    },
    getDiscordStats: async():Promise<DiscordPlayerStatsProps[]> => {
        try {
            const resp = await axios.get(`${AUTH_SVC_API}/v1/players/discord/stats`);
            return resp.data.discord_player_stats
        } catch (e) {
            return []
        }
    },
    getPlayersByPlayerIds : async(player_ids:string[]):Promise<PublicPlayerProps[]> => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/players/bulk/get`, { player_ids })
            return resp.data.players
        } catch (e) {
            return []
        }
    },
    broadcastMessage: async(message: string, targets:BroadcastTarget[]):Promise<BroadcastResult[]> => {
        try {
            const resp = await axios.post(`${BOT_SVC_API}/broadcast`, { message, targets });
            return resp.data.results
        } catch (e) {
            return []
        }
    }
}